module.exports = __webpack_public_path__ + "img/192.dc1cb214.png";